import { pickupAttemptStatusLabel } from '@/components/secondary/pickupPipelineModel';
import type { PickupAttemptStatus } from '@/types/pickupOpportunity';
import type { PickupInvestorPricingRow } from './pickupInvestorPricing';

const PICKUP_ANSWERED_ATTEMPT_STATUSES = new Set<PickupAttemptStatus>([
  'approved',
  'declined',
  'transferred',
  'cannot_transfer',
  'skipped'
]);

export type PickupInvestorPricingRankState = 'unanswered' | 'answered' | 'unranked';

export function pickupInvestorPricingRankState(
  row: PickupInvestorPricingRow
): PickupInvestorPricingRankState {
  if (row.rank === null) {
    return 'unranked';
  }
  return row.attemptStatus && PICKUP_ANSWERED_ATTEMPT_STATUSES.has(row.attemptStatus)
    ? 'answered'
    : 'unanswered';
}

export function pickupInvestorPricingGainDollars(
  row: PickupInvestorPricingRow
): number | null {
  return row.beatsLock && row.deltaDollars !== null && row.deltaDollars > 0
    ? row.deltaDollars
    : null;
}

export function pickupInvestorPricingStatusLabel(row: PickupInvestorPricingRow): string {
  if (row.attemptStatus === 'pending_investor_response') {
    return 'Awaiting answer';
  }
  if (row.attemptStatus) {
    return pickupAttemptStatusLabel(row.attemptStatus);
  }
  if (row.currentInvestor) {
    return 'Current investor';
  }
  return row.beatsLock ? 'Available' : 'Below lock';
}

export function pickupInvestorPricingStatusClass(row: PickupInvestorPricingRow): string {
  if (row.attemptStatus === 'approved' || row.attemptStatus === 'transferred') {
    return 'border-success/50 bg-success/10 text-success-strong';
  }
  if (row.attemptStatus === 'declined'
    || row.attemptStatus === 'cannot_transfer'
    || row.attemptStatus === 'stale') {
    return 'border-destructive/50 bg-destructive/10 text-destructive';
  }
  if (row.attemptStatus || row.currentInvestor) {
    return 'border-warning/50 bg-warning/10 text-warning-strong';
  }
  return row.beatsLock
    ? 'border-success/40 bg-success/5 text-success-strong'
    : 'border-border bg-muted/60 text-muted-foreground';
}
